$(function () {
  $(".lang-switcher").each(function () {
    const $langSwitcher = $(this);
    const $activeLang = $langSwitcher.find(".lang-switcher__active-lang");
    const $langSwitcherModal = $langSwitcher.parent().find('.lang-switcher__modal');

    if ($activeLang.length > 0 && $langSwitcherModal.length > 0) {
      $activeLang.on("blur", function (e) {
        if (
          !e.relatedTarget ||
          (!e.relatedTarget.closest(".lang-switcher__dropdown") &&
            !e.relatedTarget.closest(".lang-switcher__modal"))
        ) {
          $langSwitcherModal.removeClass("open");
          $activeLang.removeClass("open");
        }
      });

      $langSwitcher.on("click", function () {
        if ($langSwitcherModal.hasClass("open")) {
          $activeLang.trigger("blur");
        } else {
          $(".lang-switcher__active-lang.open").each(function () {
            $(this).trigger("blur");
          });
          $(".country-switcher__active-country.open").each(function () {
            $(this).trigger("blur");
          });

          $langSwitcherModal.addClass("open");
          $activeLang.addClass("open");
        }
      });
    }
  });
});
